import { render, staticRenderFns } from "./StatisticsColumn.vue?vue&type=template&id=f408fe38&"
import script from "./StatisticsColumn.vue?vue&type=script&lang=js&"
export * from "./StatisticsColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f408fe38')) {
      api.createRecord('f408fe38', component.options)
    } else {
      api.reload('f408fe38', component.options)
    }
    module.hot.accept("./StatisticsColumn.vue?vue&type=template&id=f408fe38&", function () {
      api.rerender('f408fe38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/TouchpointOverview/Statistics/Page/StatisticsColumn.vue"
export default component.exports